<template>
  <div>
    <div class="row">
      <div class="col-4 mx-auto my-5 text-center">
        <pdf src="/BeeReaders - Manual General de Usuario - 2020.pdf"></pdf>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-logo h3 text-center">
        Manual de Usuario
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 subtitle text-center mx-auto">
        <!-- Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce vel
        lobortis nisl. In id cursus neque, sed luctus leo. -->
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-12 text-center">
        <button class="button primary" @click="showNotification">
          <a
            class="text-white download"
            href="/BeeReaders - Manual General de Usuario - 2020.pdf"
            download
          >
            Descargar
          </a>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <button class="button secondary" @click="showModal.modalPreview = true">
          Previsualizar
        </button>
      </div>
    </div>
    <ModalPreview
      v-if="showModal.modalPreview"
      @close="showModal.modalPreview = false"
    />
  </div>
</template>

<script>
import ModalPreview from "@/components/userManual/ModalPreview";
import pdf from "vue-pdf";

export default {
  name: "UserManual",
  data() {
    return {
      showModal: {
        modalPreview: false,
      },
    };
  },
  components: {
    ModalPreview,
    pdf,
  },
  methods: {
    showNotification() {
      this.$notify({
        title: ["PDF Descargado"],
        type: "success",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.download:hover {
  text-decoration: none;
}
</style>
